<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="pageName"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
    </div>
    <br>
    <br>
    <div class="container st-form webtext-black">
      <div *ngIf="this.displayPromoCodeTextBox">
        <div>
          <app-st-input-text [idVal]="'promo-code-text-id'" [label]="'Promo Code'"></app-st-input-text>
        </div>
        <br><br>
      </div>
      <app-st-span [inputVal]="'Your default payment card will be charged immediately.'"></app-st-span>
      <br>
      <app-st-span [inputVal]="'NOTE: Subscription changes are prorated based on time and usage.'"></app-st-span>
      <br><br>
      <div class="row">
        <div *ngFor="let subscriptionPricePlan of subscriptionPricePlans;  let i1 = index" class="col-sm-4" >
          <div class="card">
            <div class="card-body">
              <h5 class="card-title webtext-black">{{subscriptionPricePlan.subscriptionPlanDisplayName}}</h5>
              <h5 class="card-title webtext-black">{{subscriptionPricePlan.displayLength}}</h5>
              <br>
              <p class="card-text webtext-black" *ngIf="(subscriptionPricePlan['totalPrice'] < subscriptionPricePlan['originalTotalPrice'])">
                Full Price: <del>$ {{subscriptionPricePlan['originalTotalPriceFormatted']}}</del>
              </p>
              <p class="card-text webtext-black" *ngIf="(subscriptionPricePlan['totalPrice'] >= subscriptionPricePlan['originalTotalPrice'])">
                &nbsp;
              </p>
              <p class="card-text webtext-black"><i>$ {{subscriptionPricePlan['totalPriceFormatted']}} billed annually.</i></p>
              <app-st-button [idVal]="'subscription-plan-select-button-id'" [label]="'Select'" [primary]="true"
                             (click)="this.changeSubscription(subscriptionPricePlan)"></app-st-button>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
    </div>

    <br><br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'bottom-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
    </div>
    <br>
    <br>
  </div>
</div>

